export function getFundingAccountsV2(send) {
  return (query, ...args) =>
    send(
      {
        path: '/v2/fundingAccounts',
        pathParameters: {},
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
